export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line'
    },
    {
      name: 'UL Listed',
      description: 'Underwriters Laboratories Certified',
      icon: 'ri-award-line'
    },
    {
      name: 'FM Approved',
      description: 'Factory Mutual Global Approved',
      icon: 'ri-medal-line'
    },
    {
      name: 'NFPA',
      description: 'National Fire Protection Association Standards',
      icon: 'ri-file-shield-line'
    }
  ];

  return (
    <section className="py-16 bg-red-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Compliance & Certifications</h2>
            <p className="text-lg text-gray-600">
              All FlameGuardQA products meet international fire safety standards and Qatar regulations
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${cert.icon} text-red-600 text-2xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{cert.name}</h3>
                <p className="text-sm text-gray-600">{cert.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-white p-8 rounded-lg shadow-sm">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <i className="ri-information-line text-red-600 text-2xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-2">Quality Assurance</h3>
                <p className="text-gray-600">
                  All FlameGuardQA fire safety products undergo rigorous testing and quality control processes. 
                  Our systems are designed to meet or exceed Qatar Civil Defence requirements and international 
                  fire safety standards including NFPA, UL, and FM approvals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}